var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",value:({ top: -150 }),expression:"{ top: -150 }",modifiers:{"once":true}}],staticClass:"viewport"},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc18d508","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InViewport.vue
// module id = null
// module chunks = 